<template lang="pug">
  .quotation-overview
    el-table(
      v-if="data.length > 0"
      :data="data"
      :span-method="span"
      :row-style="getRowStyle"
      :row-class-name="getRowClassname"
      @header-click="onHeaderClick"
    )
      el-table-column(
        :prop="isZh ? 'category_name_ch' : 'category_name'"
        :label="$t('项目类别')"
        show-overflow-tooltip
      )
      el-table-column(
        :prop="isZh ? 'service_name_ch' : 'service_name'"
        :label="$t('服务类别')"
        show-overflow-tooltip
      )

      //- 多供应商报价
      template(v-if="isMutipleVendor")
        el-table-column(
          v-for="item, index in vendors"
          :key="index"
          :prop="String(item.sub_final_scope_vendor_id)"
          :label="'供应商' + (index + 1)"
          :render-header="renderHeader"
          align="right"
        )
          template(slot-scope="scope")
            span {{ handleDiscountRow(scope.row[('price' + index)], scope.row) | formatMoney }}

      //- 增量报价
      template(v-else-if="shouldShowIncrement")
        el-table-column(
          prop="old_total_price"
          :label="$t('原报价')"
          align="right"
        )
          template(slot-scope="scope")
            span {{ handleDiscountRow(scope.row.old_total_price, scope.row) | formatMoney }}
        el-table-column(
          prop="total_price"
          :label="$t('修改后报价')"
          align="right"
        )
          template(slot-scope="scope")
            span {{ handleDiscountRow(scope.row.total_price, scope.row) | formatMoney }}

        el-table-column(
          prop="quotation_increased"
          :label="$t('增量')"
          align="right"
        )
          template(slot-scope="scope")
            span {{ handleDiscountRow(scope.row.total_price - scope.row.old_total_price, scope.row) | formatMoney }}

        el-table-column(
          prop="quotation_increased"
          :label="$t('增率')"
          align="right"
        )
          template(slot-scope="scope")
            span {{ handleDiscountRow(scope.row.quotation_increased, scope.row) | numberWithPercent }}

      //- 普通报价
      el-table-column(
        v-else
        prop="total_price"
        :label="$t('报价')"
        align="right"
      )
        template(slot-scope="scope")
          el-input(
            v-if="scope.row.service_name_ch === '返点' && isInputRebase"
            style="width: 80px; margin-right: 10px"
            v-model="rebase"
            @change="changeRebase"
          )
            span(slot="suffix") %
          span {{ scope.row.total_price | formatMoney }}

    quotation-dialog(
      v-model="dialogVisible"
      :id="id"
    )
</template>

<script>
import { formatMoney, numberWithPercent } from '@/umcc/util'
import groupBy from 'lodash/groupBy'
import sum from 'lodash/sum'
import db from '@/umcc/db'
import QuotationDialog from '@/components/QuotationList/QuotationDialog'

export default {
  components: {
    QuotationDialog
  },
  props: {
    data: {
      type: Array,
      default () {
        return []
      }
    },
    shouldShowIncrement: {
      type: Boolean,
      default: false
    },
    vendors: {
      type: Array,
      default () {
        return []
      }
    },
    isInputRebase: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  data () {
    return {
      id: null,
      dialogVisible: false,
      rebase: null
    }
  },
  computed: {
    isDemoUser () {
      return this.$store.state.common.user.company_name === 'Mccann'
    },
    isMutipleVendor () {
      return this.vendors.length > 0
    },
    shouldMergeIndex () {
      return this.numMerged.map((item, index) => sum(this.numMerged.slice(0, index)))
    },
    numMerged () {
      const obj = groupBy(this.data, 'category_name')
      var res = []
      for (var i in obj) {
        if (obj.hasOwnProperty(i)) {
          res.push(obj[i])
        }
      }
      return res.map(i => i.length)
    },
    isZh () {
      return db.lang === 'zh'
    }
  },
  filters: {
    formatMoney,
    numberWithPercent
  },
  methods: {
    changeRebase () {
      this.$emit('changeRebase', this.rebase)
    },
    getRowStyle ({row, rowIndex}) {
      // 增量行
      if (row.is_increased) {
        return { background: '#fff8ef' }
      }
      // 折扣行
      if (row.service_name_ch === '折扣') {
        return { color: 'red' }
      }
      // 小计行
      if (row.service_name_ch === '小计') {
        return { background: '#f8f9f9' }
      }
      // 总计行
      if (row.service_name_ch === '总计（含税）') {
        return { background: '#f8f9f9' }
      }
      // 税率行
      if (row.service_name_ch === '税率（6%）') {
        return { color: 'red' }
      }
    },
    getRowClassname ({row, rowIndex}) {
      if (row.service_name_ch === '小计') return 'quotation-overview__highlight'
    },
    span ({ row, column, rowIndex, columnIndex }) {
      // 最后三行总计合并
      const num = this.isDemoUser ? 5 : 4
      if (rowIndex > this.data.length - num) {
        if (columnIndex === 0) return [1, 2]
        if (columnIndex === 1) return [0, 0]
      }

      // category 合并
      if (columnIndex === 0) {
        const index = this.shouldMergeIndex.findIndex(i => i === rowIndex)
        if (index !== -1) return [this.numMerged[index], 1]
        return [0, 0]
      }
    },
    renderHeader (h, { column, $index }) {
      return <span style="fontWeight: 400; cursor: pointer;" title="点击查看报价详情">
        {this.$t('供应商')}{$index - 1}
        <i class="iconfont icon-chakan" style="margin-left: 3px"/>
      </span>
    },
    onHeaderClick (col, evt) {
      if (isNaN(Number(col.property))) return
      this.dialogVisible = true
      this.id = Number(col.property)
    },
    handleDiscountRow (val, row) {
      if (row.service_name_ch === '折扣') return -val
      return val
    }
  }
}
</script>

<style lang="stylus">
.quotation-overview .el-table
  border-bottom 1px solid $main

.quotation-overview td:not([rowspan="1"])
  border-bottom 1px solid $main

.quotation-overview__highlight td
  border-bottom 1px solid $main
</style>
